const SiteFooter = () => (
  <footer className="bg-[#0D0030] text-white py-10 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto">
      <div className="flex flex-col lg:flex-row justify-between gap-8">
        {/* Left */}
        <div className="flex flex-col gap-4 max-w-[480px]">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#A3E635] rounded-lg flex items-center justify-center">
              <span className="text-[#1E0750] font-black text-xs">LS</span>
            </div>
            <span className="text-white font-black text-lg">LS <span className="text-[#A3E635]">INVEST</span></span>
          </div>
          <p className="text-white/40 text-xs leading-relaxed">
            Ce site ne fait pas partie du site Web de Facebook ou de Facebook Inc. De plus, ce site n&apos;est en aucun cas approuvé par Facebook. FACEBOOK est une marque commerciale de FACEBOOK, Inc.
          </p>
          <p className="text-white/40 text-xs">© 2026 LS INVEST — Tous droits réservés</p>
        </div>

        {/* Right */}
        <div className="flex flex-col gap-4">
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
            {[
              { label: 'Mentions légales', href: '#' },
              { label: 'Politique de confidentialité', href: '#' },
              { label: 'CGV', href: '#' },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-white/50 hover:text-white text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
          <p className="text-white/25 text-xs leading-relaxed max-w-[480px]">
            * Les résultats présentés ne sont pas garantis. Investir en Bourse comporte des risques de perte en capital. Ces exemples sont des résultats individuels et ne sont pas représentatifs de tous les membres.
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
